const groupsStr = {
  toastr: 'Grupo eliminado',
  toastr1: 'eliminado con éxito'
};

export default groupsStr;
